var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",on:{"pointerdown":_vm.startDrawing,"pointerup":_vm.stopDrawing,"pointermove":_vm.draw}})}
var staticRenderFns = []

export { render, staticRenderFns }